import React from 'react';
import queryString from 'query-string';
import { Carousel } from '../Carousel';
import { Link } from '../Link';
import { SectionHeading } from '../SectionHeading';
import { TruncatedTypography } from '../TruncatedTypography';
import { Typography } from '../Typography';
import { ArticleRelatedArticle } from '../../types/api';
import { Camelize } from '../../types/camelize';
import { pxToNumber } from '../../wag-react/common/utils/pxToNumber';
import { theme } from '../../wag-react/themes/base-theme';
import { Box } from '../../wag-react/next-components/box';
import { Grid } from '../../wag-react/core-components/grid';
const swiperParams = {
  slidesPerView: 1.1,
  freeMode: true,
  loop: false,
  spaceBetween: 16,
  breakpoints: {
    [pxToNumber(theme.breakpoints[0])]: {
      slidesPerView: 2.1,
      spaceBetween: 24,
      freeMode: true
    },
    [pxToNumber(theme.breakpoints[1])]: {
      slidesPerView: 3.1,
      freeMode: true
    },
    [pxToNumber(theme.breakpoints[2])]: {
      slidesPerView: 3.1,
      freeMode: true
    }
  }
};
const defaultBannerImageQueryParams = {
  height: '328',
  fit: 'scale-down'
} as const;
export type RelatedArticlesCarouselProps = {
  contentType: string;
  headingText?: string;
  value: Camelize<ArticleRelatedArticle>[];
};
export const RelatedArticlesCarousel = ({
  contentType,
  headingText = 'You may also like',
  value
}: RelatedArticlesCarouselProps) => {
  const newRelatedArticleItems = value.map(item => ({
    ...item,
    bannerImage: [
    // TODO - Why the cloudflareParser not working with this domain?
    queryString.stringifyUrl({
      url: item.bannerImage,
      query: {
        ...defaultBannerImageQueryParams,
        width: '200'
      }
    }), null, queryString.stringifyUrl({
      url: item.bannerImage,
      query: {
        ...defaultBannerImageQueryParams,
        width: '344'
      }
    })]
  }));
  return <Box m="0 auto" data-sentry-element="Box" data-sentry-component="RelatedArticlesCarousel" data-sentry-source-file="index.tsx">
      <SectionHeading fontSize="26px" color="#474747" my="30px" data-sentry-element="SectionHeading" data-sentry-source-file="index.tsx">
        {headingText}
      </SectionHeading>
      <Carousel keyExtractor={(item: ArticleRelatedArticle) => item.title} navigation={false} value={newRelatedArticleItems} px="0" swiperParams={swiperParams} data-sentry-element="Carousel" data-sentry-source-file="index.tsx">
        {(item: Camelize<ArticleRelatedArticle>) => <Link href={item.src} target="_blank" height="328px" width={['200px', '344px']}>
            <Box height="328px" borderRadius="8px" overflow="hidden">
              <Box backgroundImage={`url(${item.bannerImage})`} backgroundPosition="center" backgroundSize="cover" backgroundRepeat="no-repeat" height="232px" />
              <Box height="150px" p="16px" mt="-80px" backgroundColor="white" borderRadius="8px" mx="16px">
                <Grid gridTemplateRows="18px 72px 18px" textAlign="center">
                  <Typography variant="body2" color="wagGreen" fontSize="14px" hover style={{
                textTransform: 'uppercase'
              }}>
                    {contentType}
                  </Typography>
                  <Box>
                    <TruncatedTypography fontSize="18px" fontFamily="muliBold" color="#474747" my="8px" lineClamp={3} text={item.title} hover />
                  </Box>
                </Grid>
              </Box>
            </Box>
          </Link>}
      </Carousel>
    </Box>;
};